<div class="pt-3 d-block radio-block {{class}}">
  <label class="custom-radio d-flex align-items-center" *ngFor="let answer of question.answers_options">
    <input type="radio" id="radio{{answer.id}}" [attr.name]="'radio_' + answer.id" [(ngModel)]="selectedAnswer"
           (change)="onAnswerChange()" [value]="answer.id" [disabled]="disabled">
    <span class="checkmark"></span>
    <span class="text-label-rb small" [innerHtml]="answer.label"></span>
  </label>
</div>

